// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  PercentileMetric,
  PercentileTargetListMetricsOptionalParams,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a PercentileTarget. */
export interface PercentileTarget {
  /**
   * Retrieves the metrics determined by the given filter for the given account target region. This url
   * is only for PBS and Replication Latency data
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param accountName Cosmos DB database account name.
   * @param targetRegion Target region to which data is written. Cosmos DB region, with spaces between
   *                     words and each word capitalized.
   * @param filter An OData filter expression that describes a subset of metrics to return. The
   *               parameters that can be filtered are name.value (name of the metric, can have an or of multiple
   *               names), startTime, endTime, and timeGrain. The supported operator is eq.
   * @param options The options parameters.
   */
  listMetrics(
    resourceGroupName: string,
    accountName: string,
    targetRegion: string,
    filter: string,
    options?: PercentileTargetListMetricsOptionalParams,
  ): PagedAsyncIterableIterator<PercentileMetric>;
}
